exports.name = 'IHMozuFuru';



// WEBPACK FOOTER //
// ./map/js/ih_class_name.js